export enum ENVIRONMENT {
  SANDBOX = 'sandbox',
  PRODUCTION = 'production',
}

export enum ENVIRONMENT_TABS {
  PRODUCTION = 0,
  SANDBOX = 1,
}
